import React from 'react';
import LocationTemplate from './LocationTemplate';

const FranklintonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Franklinton"
      stateName="North Carolina"
      countyName="Franklin"
      zipCodes={["27525"]}
      latitude={36.1043}
      longitude={-78.4578}
      population={2253}
      historicalFact="Founded in 1839, originally called Franklin Depot on the Raleigh and Gaston Railroad."
      nearbyTowns={[
        "Louisburg, NC",
        "Wake Forest, NC",
        "Youngsville, NC",
        "Bunn, NC",
        "Henderson, NC",
        "Oxford, NC",
        "Creedmoor, NC",
        "Rolesville, NC"
      ]}
    />
  );
};

export default FranklintonPage;